import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../auth/AuthService";

export default function OidcCallback() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        
        // 使用新的認證服務處理回調
        const user = await authService.handleSigninCallback();
        
        if (user && !user.expired) {
          
          // 檢查預定的目的地
          const intendedDestination = sessionStorage.getItem('intendedDestination');
          
          if (intendedDestination) {
            sessionStorage.removeItem('intendedDestination');
            navigate(intendedDestination);
          } else {
            // 默認導向首頁
            navigate('/');
          }
        } else {
          throw new Error("認證失敗或 token 已過期");
        }
      } catch (error: any) {
        console.error("OIDC 回調處理失敗:", error);
        setError(error.message || "認證處理失敗");
        
        // 3 秒後導向首頁
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <h1 className="text-2xl font-bold text-blue-800 mb-4">處理登入中...</h1>
          <p className="text-gray-700">請稍候，正在完成認證流程</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">認證失敗</h1>
          <p className="text-gray-700 mb-4">{error}</p>
          <p className="text-gray-500">3 秒後將自動返回首頁...</p>
        </div>
      </div>
    );
  }

  return null;
}